import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import cx from 'classnames';
import { Popover } from 'grab-ui';
import I18n from 'i18n-js';
import styles from './index.less';

const Step = ({ step, finished, canGo, goToStep }) => (
  <Popover
    trigger={'hover'}
    placement={'top'}
    content={
      <div className={styles.stepPopup}>
        <b className={styles.bold}>Step {step}:</b>{' '}
        {I18n.t(`bulkUploadRevamp.stepName.${step}`)}
      </div>
    }
  >
    <div
      className={cx(styles.step, {
        [styles.finished]: finished,
        [styles.clickable]: canGo,
        [styles.nonclickable]: !canGo && !finished,
      })}
      onClick={canGo ? () => goToStep(step) : undefined}
    />
  </Popover>
);

Step.propTypes = {
  step: PropTypes.number.isRequired,
  finished: PropTypes.bool.isRequired,
  canGo: PropTypes.bool.isRequired,
  goToStep: PropTypes.func.isRequired,
};

const StepIndicator = ({ className, goToStep, currentStep, totalSteps }) => {
  const steps = useMemo(
    () => {
      const steps = [];
      for (let step = 1; step <= totalSteps; step++) {
        steps.push(
          <Step
            key={step}
            step={step}
            finished={step <= currentStep}
            canGo={step < currentStep}
            goToStep={goToStep}
          />,
        );
      }
      return steps;
    },
    [currentStep, totalSteps, goToStep],
  );
  return <div className={cx(styles.stepIndicator, className)}>{steps}</div>;
};

StepIndicator.propTypes = {
  className: PropTypes.string.isRequired,
  goToStep: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default StepIndicator;
